<template>
  <div class="info-box" v-if="isShowInfo" @click="itemClick">
    <div class="info-title-box">
      <div class="info-title">
        {{ currentKeyword }}
      </div>
      <div
        class="info-addLink"
        @click.stop.prevent="handleShowAddLinkDialog"
      >
        +
      </div>
    </div>
    <div class="info-content-box" v-if="bookList.length">
      <div v-if="bookList[0].book_keywords_id">
        <div
          v-for="item in bookList"
          class="item-info"
          :key="item.id"
        >
          <img
            :src="`${item.book_image}`"
            alt=""
            style=""
            class="info-box-img"
            @click="showBookDetail(item.book_id)"
          />
          <div>
            <div style="font-size: 14px">{{ item.description }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          style="
            overflow-y: scroll;
            word-wrap: break-word;
            font-size: 14px;
            padding: 5px 0;
          "
          class="no-scroll-bar"
          v-html="bookList[0].description"
        ></div>
      </div>
    </div>

    <!-- 添加链接弹框 -->
    <div v-if="showAddLinkDialog" class="add-link-dialog-mask" @click="handleCloseAddLinkDialog">
      <div class="add-link-dialog" @click.stop>
        <div class="add-link-dialog-header">
          <h3 class="add-link-dialog-title">添加链接</h3>
          <i class="el-icon-close add-link-dialog-close" @click="handleCloseAddLinkDialog"></i>
        </div>
        <div class="add-link-dialog-content">
          <div class="add-link-keyword">
            <span class="add-link-label">关键词:</span>
            <span class="add-link-keyword-text">{{ currentKeyword }}</span>
          </div>
          <div class="add-link-input-wrapper">
            <input
              v-model="relatedKeyword"
              type="text"
              class="add-link-input"
              placeholder="请输入关联词条"
              @input="handleSearchInput"
            />
            <i class="el-icon-search add-link-search-icon"></i>
            <!-- 搜索结果列表 -->
            <div v-if="isShowSearchResult && searchResultEntry.length > 0" class="add-link-search-result">
              <div
                v-for="(item, index) in searchResultEntry"
                :key="index"
                class="add-link-search-item"
                @click="handleSelectSearchItem(item)"
              >
                {{ item.user }}
              </div>
            </div>
            <div v-if="isShowSearchResult && searchResultEntry.length === 0 && relatedKeyword.trim()" class="add-link-no-result">
              暂无词条
            </div>
          </div>
          <div class="add-link-arrows">
            <div
              v-for="(arrow, index) in arrowImages"
              :key="index"
              class="add-link-arrow-item"
              :class="{ 'active': selectedArrowIndex === index }"
              @click="selectedArrowIndex = index"
            >
              <img :src="arrow.url" :alt="arrow.name" class="add-link-arrow-img" />
            </div>
          </div>
          <div v-if="selectedArrowIndex !== null" class="add-link-tip">
            {{ arrowTips[selectedArrowIndex] }}
          </div>
          <div class="add-link-dialog-buttons">
            <button class="add-link-btn cancel-btn" @click="handleCloseAddLinkDialog">取消</button>
            <button class="add-link-btn confirm-btn" @click="handleConfirmAddLink">确认</button>
          </div>
        </div>
      </div>
    </div>
</div>

</template>
<script>

// import axios from '@/http'
import request from '@/http/request'
export default {
  data () {
    return {
      isShowInfo: false,
      bookList: [],
      // 添加链接弹框
      showAddLinkDialog: false,
      relatedKeyword: '', // 关联词条输入
      selectedArrowIndex: null, // 选中的箭头索引（0-3）
      // 搜索结果
      isShowSearchResult: false,
      searchResultEntry: [], // 词条搜索结果
      searchDebounceTimer: null, // 防抖定时器
      selectedSearchItem: null, // 选中的搜索项信息
      arrowImages: [
        { url: 'https://oss.bookor.com.cn/static/img/mini_programs/images/20220309/arrow-1.png', name: 'arrow-1' },
        { url: 'https://oss.bookor.com.cn/static/img/mini_programs/images/20220309/arrow-2.png', name: 'arrow-2' },
        { url: 'https://oss.bookor.com.cn/static/img/mini_programs/images/20220309/arrow-3.png', name: 'arrow-3' },
        { url: 'https://oss.bookor.com.cn/static/img/mini_programs/images/20220309/arrow-4.png', name: 'arrow-4' }
      ],
      arrowTips: [
        '两个词条互为平等推导关系。比如："乌合之众"和"群体心理学"',
        '单向推导，即因果关系。',
        '弱双向关联的关系。比如"狄更斯"和"英国人"。',
        '弱单向关联关系。'
      ]
    }
  },
  props: ['currentBookId', 'currentNodeId', 'currentKeyword', 'forceData', 'bondList'],
  components: {
  },
  watch: {
    currentBookId (val) {
      if (!val) {
        this.isShowInfo = false
        return
      }
      this.getBookDetail()
    },
    currentNodeId (val) {
      if (!val) {
        this.isShowInfo = false
        return
      }
      this.getBookDetail()
    }
  },
  methods: {
    showBookDetail (id) {
      this.$emit('showBookDetail', id)
    },
    itemClick () {
      // 如果弹框打开，点击其他地方关闭弹框
      if (this.showAddLinkDialog) {
        this.showAddLinkDialog = false
      }
    },
    // 显示添加链接弹框
    handleShowAddLinkDialog (event) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      this.relatedKeyword = ''
      this.selectedArrowIndex = null
      this.showAddLinkDialog = true
      // 确保弹窗挂载到body并设置最高z-index
      this.$nextTick(() => {
        const dialogMask = document.querySelector('.add-link-dialog-mask')
        if (dialogMask && dialogMask.parentElement !== document.body) {
          document.body.appendChild(dialogMask)
        }
        if (dialogMask) {
          dialogMask.style.zIndex = '999999'
        }
      })
    },
    // 关闭添加链接弹框
    handleCloseAddLinkDialog () {
      this.showAddLinkDialog = false
      this.relatedKeyword = ''
      this.selectedArrowIndex = null
      this.isShowSearchResult = false
      this.searchResultEntry = []
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
        this.searchDebounceTimer = null
      }
    },
    // 处理搜索输入
    handleSearchInput () {
      // 清除之前的定时器
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }
      
      // 如果输入为空，隐藏搜索结果
      if (!this.relatedKeyword.trim()) {
        this.isShowSearchResult = false
        this.searchResultEntry = []
        return
      }
      
      // 防抖处理，300ms后执行搜索
      this.searchDebounceTimer = setTimeout(() => {
        this.onSearchInputAll()
      }, 300)
    },
    // 搜索所有词条
    onSearchInputAll () {
      if (!this.relatedKeyword.trim()) {
        this.isShowSearchResult = false
        this.searchResultEntry = []
        return
      }
      
      this.isShowSearchResult = true
      this.apiGetSearchResult()
    },
    // 获取搜索结果
    apiGetSearchResult () {
      if (!this.forceData || !this.bondList) {
        this.searchResultEntry = []
        return
      }
      
      const keyword = this.relatedKeyword.trim().toLowerCase()
      let list = []
      const seenItems = new Set()
      const seenTexts = new Set()
      
      // 从 bondList 中搜索
      this.bondList.forEach((item) => {
        if (item.title && item.title.length === 1) {
          const child = item.title[0]
          if (child.lines_title && child.lines_title.toLowerCase().includes(keyword)) {
            const normalizedTitle = child.lines_title.trim()
            const normalizedText = normalizedTitle.toLowerCase().replace(/\s+/g, '')
            const uniqueKey = `${normalizedTitle.toLowerCase()}_${child.mix_keywords_lines_id}`
            
            if (!seenItems.has(uniqueKey) && !seenTexts.has(normalizedText)) {
              seenItems.add(uniqueKey)
              seenTexts.add(normalizedText)
              list.push({
                user: normalizedTitle,
                id: child.mix_keywords_lines_id,
                type: 'KEYWORD_TITLE'
              })
            }
          }
        }
      })
      
      // 从 forceData.nodes 中搜索
      if (this.forceData.nodes) {
        const nodes = this.forceData.nodes.filter((item) => {
          if (!item.user || !item.user.toLowerCase().includes(keyword)) return false
          
          const normalizedUser = item.user.trim()
          const normalizedText = normalizedUser.toLowerCase().replace(/\s+/g, '')
          
          if (seenTexts.has(normalizedText)) {
            return false
          }
          
          const uniqueKey = `${normalizedUser.toLowerCase()}_${item.nodeId || item.id}`
          seenItems.add(uniqueKey)
          seenTexts.add(normalizedText)
          item.user = normalizedUser
          return true
        })
        
        list = [...list, ...nodes]
      }
      
      this.searchResultEntry = list
    },
    // 选择搜索结果项
    handleSelectSearchItem (item) {
      this.relatedKeyword = item.user
      this.selectedSearchItem = item // 保存选中的搜索项信息
      this.isShowSearchResult = false
    },
    // 确认添加链接
    async handleConfirmAddLink () {
      // 验证必填项
      if (!this.relatedKeyword || !this.relatedKeyword.trim()) {
        this.$message.warning('请输入关联词条')
        return
      }
      
      if (this.selectedArrowIndex === null || this.selectedArrowIndex === undefined) {
        this.$message.warning('请选择关系类型')
        return
      }
      
      if (!this.currentKeyword || !this.currentKeyword.trim()) {
        this.$message.warning('当前关键词无效')
        return
      }
      
      try {
        // 调用接口保存关系
        // lines_code 需要 +1，因为 selectedArrowIndex 是 0-3，但接口需要 1-4
        await request('/api/Keywords/addMixKeywordsLines', {
          keywords_front: this.currentKeyword.trim(), // 当前关键词作为前置关键词
          keywords_behind: this.relatedKeyword.trim(), // 用户输入的关联词条作为后置关键词
          lines_code: this.selectedArrowIndex + 1 // 选中的箭头索引（1-4）
        })
        
        // request 函数在 code === 200 时会 resolve，否则会 reject
        this.$message.success('绑定成功')
        
        // 通知父组件更新关联节点列表
        if (this.selectedSearchItem) {
          // 构建新词条信息
          // 从搜索结果项中提取 ID 信息
          let book_keywords_id = null
          let member_keywords_id = null
          
          if (this.selectedSearchItem.bookId) {
            book_keywords_id = this.selectedSearchItem.bookId
          } else if (this.selectedSearchItem.book_keywords_id) {
            book_keywords_id = this.selectedSearchItem.book_keywords_id
          }
          
          if (this.selectedSearchItem.nodeId) {
            member_keywords_id = this.selectedSearchItem.nodeId
          } else if (this.selectedSearchItem.member_keywords_id) {
            member_keywords_id = this.selectedSearchItem.member_keywords_id
          } else if (this.selectedSearchItem.id && !this.selectedSearchItem.type) {
            // 如果 id 存在且不是 KEYWORD_TITLE 类型，则可能是 member_keywords_id
            member_keywords_id = this.selectedSearchItem.id
          }
          
          const newKeyword = {
            keywords: this.selectedSearchItem.user,
            book_keywords_id: book_keywords_id,
            member_keywords_id: member_keywords_id
          }
          // 发送事件通知父组件
          this.$emit('addRelatedKeyword', newKeyword)
        } else {
          // 如果没有选中的搜索项，尝试从搜索结果中查找匹配的词条
          const matchedItem = this.searchResultEntry.find(
            item => item.user === this.relatedKeyword.trim()
          )
          if (matchedItem) {
            let book_keywords_id = null
            let member_keywords_id = null
            
            if (matchedItem.bookId) {
              book_keywords_id = matchedItem.bookId
            } else if (matchedItem.book_keywords_id) {
              book_keywords_id = matchedItem.book_keywords_id
            }
            
            if (matchedItem.nodeId) {
              member_keywords_id = matchedItem.nodeId
            } else if (matchedItem.member_keywords_id) {
              member_keywords_id = matchedItem.member_keywords_id
            } else if (matchedItem.id && !matchedItem.type) {
              member_keywords_id = matchedItem.id
            }
            
            const newKeyword = {
              keywords: matchedItem.user,
              book_keywords_id: book_keywords_id,
              member_keywords_id: member_keywords_id
            }
            this.$emit('addRelatedKeyword', newKeyword)
          }
        }
        
        this.handleCloseAddLinkDialog()
      } catch (error) {
        console.error('绑定失败:', error)
        this.$message.error(error?.message || '绑定失败，请重试')
      }
    },
    getBookDetail () {
      request('/api/keywords/getDescriptionByKeyWordsId', {
        book_keywords_id: this.currentBookId,
        member_keywords_id: this.currentNodeId
      }).then((result) => {
        if (result.book_keywords_description.length === 0 && !result.member_keywords_description) {
          this.isShowInfo = false
          return
        }
        this.isShowInfo = true
        if (result.book_keywords_description.length) {
          this.bookList = result.book_keywords_description
        } else {
          this.bookList = [result.member_keywords_description]
        }
      })
    }
  },
  mounted () {
    if (this.currentBookId || this.currentNodeId) {
      this.getBookDetail()
    }
  }
}
</script>

<style scoped lang="scss">

.info-box-img {
  width: 75px;
  height: 100px;
  float: left;
  margin-right: 8px;
  cursor: pointer;
}
.info-box {
  // position: absolute;
  position: relative;
  margin-left: 10px;
  background-color: #222f36;
  color: white;
  border-radius: 10px;
  min-width: 240px;
  height: 320px;
  max-width: 300px;
  z-index: 99;
  border: 2px solid #404040;
  overflow: hidden;
}
.info-box:first-child{
  border: 2px solid #8faadc
}
.item-info{
  margin-bottom: 15px;
  display: flex;
  gap: 4px;
}
.info-content-box {
  border-top: 1px dotted #ffffff;
  overflow-y: scroll;
  height: 240px;
  padding: 12px;
  padding-bottom: 30px;
}

.info-box::-webkit-scrollbar {
  display: none;
}

.info-box-array-outter {
  &::-webkit-scrollbar {
    display: none;
  }
}

.info-box-array {
  background-color: #222f36;
  color: white;
  border: 2px solid #404040;
  border-radius: 10px;
  min-width: 20vw;
  position: relative;
  /* min-height: 60px; */
  /* max-height: 30vh; */
  max-width: 300px;
  /* padding: 0 5px; */
  overflow-y: scroll;
  /* padding: 3px 10px; */
  display: inline-block;
  margin-left: 5px;
  z-index: 1;
}

.info-box-array::-webkit-scrollbar {
  display: none;
}

.info-title-box {
  display: flex;
  align-items: center;
  background-color: #1a2329;
  width: 100%;
  border-radius: 12px;
}

.info-title {
  background-color: #1a2329;
  color: white;
  /* border-radius: 6px; */
  font-weight: 600;
  padding: 8px 8px;
  /* display: inline-block; */
  /* margin: 5px 0; */
  font-size: 15px;
  // width: 100%;
  box-sizing: border-box;
}

.info-box-array-html {
  overflow-y: scroll;
  word-wrap: break-word;
  font-size: 15px;
}

.info-box-array-html::-webkit-scrollbar {
  display: none;
}

.info-content-box::-webkit-scrollbar {
  display: none;
}

.info-addLink {
  color: white;
  border: 2px solid #2a75b5;
  margin: 5px;
  padding: 0 3px;
  border-radius: 3px;
  font-weight: bold;
  height: 18px;
  line-height: 16px;
  cursor: pointer;
  user-select: none;
  pointer-events: auto;
  position: relative;
  z-index: 10;
}

/* 鼠标放大镜 */
.cursor-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: none;
  position: absolute;
  z-index: 9999;
}

.cursor-circle:active {
  display: none;
}

.no-scroll-bar::-webkit-scrollbar {
  display: none;
}

.visible-marker {
  position: absolute;
  z-index: 9999;
  margin: 0;
  pointer-events: none;
  color: red;
  font-size: 12px;
  text-align: center;
  line-height: 1.2;
  background-color: rgba(255, 255, 255, 0.3);
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.6),
    0 0 3px rgba(0, 0, 0, 0.4);
}

/* 添加链接弹框样式 */
.add-link-dialog-mask {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-link-dialog {
  background: #ffffff;
  border-radius: 8px;
  width: 380px;
  max-width: 90vw;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  position: relative;
}

.add-link-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e5e5;
}

.add-link-dialog-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.add-link-dialog-close {
  font-size: 18px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
}

.add-link-dialog-close:hover {
  color: #333;
}

.add-link-dialog-content {
  padding: 20px;
}

.add-link-keyword {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.add-link-label {
  font-size: 13px;
  color: #666;
  margin-right: 8px;
}

.add-link-keyword-text {
  font-size: 13px;
  color: #ff0000;
  font-weight: 500;
}

.add-link-input-wrapper {
  position: relative;
  margin-bottom: 18px;
}

.add-link-search-result {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  margin-top: 4px;
}

.add-link-search-item {
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  font-size: 13px;
  color: #333;
  transition: background-color 0.2s;
}

.add-link-search-item:hover {
  background-color: #f5f7fa;
  color: #409eff;
}

.add-link-search-item:last-child {
  border-bottom: none;
}

.add-link-no-result {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 10px 12px;
  font-size: 13px;
  color: #999;
  text-align: center;
  z-index: 1000;
  margin-top: 4px;
}

.add-link-input {
  width: 100%;
  height: 36px;
  padding: 0 36px 0 10px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.add-link-input:focus {
  outline: none;
  border-color: #409eff;
}

.add-link-search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #999;
  pointer-events: none;
}

.add-link-arrows {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 8px;
}

.add-link-arrow-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: 2px solid #e5e5e5;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  background: #fff;
}

.add-link-arrow-item:hover {
  border-color: #409eff;
  background: #f0f9ff;
}

.add-link-arrow-item.active {
  border-color: #409eff;
  background: #e6f3ff;
}

.add-link-arrow-img {
  width: 100%;
  height: auto;
  max-height: 32px;
  object-fit: contain;
}

.add-link-tip {
  margin-bottom: 18px;
  padding: 10px;
  background: #fff7e6;
  border-left: 3px solid #ffa940;
  border-radius: 4px;
  font-size: 12px;
  color: #ff0000;
  line-height: 1.5;
}

.add-link-dialog-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.add-link-btn {
  padding: 8px 20px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-btn {
  background: #fff;
  color: #666;
  border: 1px solid #dcdcdc;
}

.cancel-btn:hover {
  background: #f5f5f5;
  border-color: #bbb;
}

.confirm-btn {
  background: #409eff;
  color: #fff;
}

.confirm-btn:hover {
  background: #66b1ff;
}

@media (max-width: 700px) {
  .info-box-array {
    min-width: 30vw;
  }

  .info-box-img {
    width: 15vw !important;
    height: 23vw !important;
  }

  .add-link-dialog {
    width: 90vw;
    max-width: 90vw;
  }

  .add-link-arrows {
    gap: 8px;
  }

  .add-link-arrow-item {
    padding: 8px;
  }
}
</style>
